export const MEDIUM_RISK_SCORE_THRESHOLD = 4;
export const HIGH_RISK_SCORE_THRESHOLD = 6;
export const CRITICAL_RISK_SCORE_THRESHOLD = 8;

export const APERTURE_ENVIRONMENT_NAME = "Aperture";
export const APERTURE_WELCOME_COOKIE = "show_aperture_welcome";

export const AGENTS_ENVIRONMENT_NAME = "default";

//==============================================
// Alert Trigger Options
//==============================================

export const REVIEW_STATUS_OPTIONS = [
  { value: "allowed", label: "Allowed" },
  { value: "unreviewed", label: "Unreviewed" },
  { value: "disallowed", label: "Disallowed" },
] as const;

export const SEVERITY_OPTIONS = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "critical", label: "Critical" },
] as const;

export const SEVERITY_DESCRIPTIONS: Record<string, string> = {
  critical: "You receive every alert immediately",
  high: "Alerts are grouped and sent hourly",
  medium: "Alerts are grouped and sent daily",
  low: "Alerts are grouped and sent weekly",
};
